import {fromJS} from 'immutable'

import {
  SET_RECENT_CONVERSATIONS,
  SET_RECENT_CONVERSATION_USER
} from '../action_types'

const setConvs = (state, convs) => state.set('_convs', convs)
const setUser = (state, user) => state.setIn(['_users', user.get('uid')], user)

const setSegment = (state, convs, users) => {
  if (!convs || !users) return state

  const segment = convs
    .map((conv, uid) => conv.merge(users.get(uid)))
    .toList()
    .filter((conv) => typeof conv.get('uid') === 'string')
    .sortBy((conv) => conv.get('latestMessageTime') ? -1 * conv.get('latestMessageTime') : 0)

  return state.set('segment', segment)
}

export default (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_RECENT_CONVERSATIONS:
      state = setConvs(state, fromJS(action.recentConversations))
      state = setSegment(state, state.get('_convs'), state.get('_users'))

      return state

    case SET_RECENT_CONVERSATION_USER:
      state = setUser(state, fromJS(action.user))
      state = setSegment(state, state.get('_convs'), state.get('_users'))

      return state

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/recent_conversations_view_reducer.js
 **/